// @ts-nocheck
import React, { useCallback, useRef, useState } from "react";
import { Container } from "./styles";

// Número do pedido (service_code, ex.: PT639914/TR1) com botão de copiar.
export default function PedidoNumero({ code, hint, className }) {
  const [copied, setCopied] = useState(false);
  const codeRef = useRef(null);

  const handleCopy = useCallback(() => {
    const done = () => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    };

    // Sem acesso à área de transferência, seleciona o número para o cliente copiar.
    const selectCode = () => {
      const range = document.createRange();
      range.selectNodeContents(codeRef.current);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    };

    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(selectCode);
    } else {
      selectCode();
    }
  }, [code]);

  if (!code) return null;

  return (
    <Container className={className}>
      <div className="pedido-linha">
        <strong>
          Pedido <span ref={codeRef}>{code}</span>
        </strong>
        <button type="button" onClick={handleCopy}>
          {copied ? "copiado" : "copiar"}
        </button>
      </div>
      {hint && (
        <p>
          Use este número no envelope dos documentos e em qualquer contato com a
          gente.
        </p>
      )}
    </Container>
  );
}
